<style scoped>
.mt-70px{
    margin-top: 70px;
}
</style>
<template>
    <div class="container mt-70px">

        <div class="row">
    
            <!-- Blog Entries Column -->
            <div class="col-md-8" id="BlogPosts">
    
            <h1 class="my-4 d-flex justify-content-between">
                <div>
                <i class="fas fa-tags"></i>
                <small>{{ this.title }}</small>
                </div>
                <div>
                    <button class="btn btn-sm btn-secondary" @click.prevent="backToNormal"><i class="fas fa-blog"></i> Voltar</button>
                </div>
            </h1>
            <img class="img-fluid" :src="`https://${this.location}/images/blog/categories/${description.photo}`" alt="Imagem da categoria">
            <hr>
            <p class="text-center">{{ this.description.description }}</p>
            <hr>
            <blog-card
                v-for="post in blogInfo.data"
                v-bind:key="post.id"
                v-bind:blogPost="post"
            ></blog-card>
    
            <!-- Pagination -->
            <div class="d-flex justify-content-center">
                <pagination :data="blogInfo" @pagination-change-page="getResults"></pagination>
            </div>
    
            </div>
    
            <!-- Sidebar Widgets Column -->
            <div class="col-md-4">
    
            <procura-card></procura-card>
    
            <categorias-widget></categorias-widget>

            <tags-widget></tags-widget>            
    
            <!-- {{-- Side Widget 
            <div class="card my-4">
                <h5 class="card-header">Side Widget</h5>
                <div class="card-body">
                You can put anything you want inside of these side widgets. They are easy to use, and feature the new Bootstrap 4 card containers!
                </div>
            </div> --}} -->
    
            </div>
    
        </div>
        <!-- /.row -->

    </div>
</template>

<script>
    import BlogCard from "./BlogCard.vue";
    export default {
        data(){
            return {
                title: this.$parent.$data.categoria,
                blogInfo: {},
                description: {},
                location: window.location.host
            }
        },
        mounted() {
            this.getResults();
            $('.back-to-top').click();
            Fire.$on('muda-categoria', () => {
                this.title =  this.$parent.$data.categoria;
                this.getResults();
            });
            Fire.$on('voltar', () =>{
                this.backToNormal();
            });
            jQuery(document).ready(function($) {

                if (window.history && window.history.pushState  && typeof window.post === 'undefined') {

                    window.history.pushState('forward', null, './#forward');

                    $(window).on('popstate', function() {
                        Fire.$emit('voltar');
                    });

                }
            });
        },
        methods:{
            getResults(page = 1) {
                this.$Progress.start();
                axios.post('/api/postsFromCategory?page='+page, {
                    categoria: this.title,
                })
                .then(response => {
                    this.$Progress.finish();
                    this.blogInfo = response.data[0];
                    this.description = response.data[1][0];
                });
/*                 axios.get('/api/blog?page='+page)
                    .then(response => {
                        this.$Progress.finish();
                        this.blogInfo = response.data;
                    }); */
            },
            viewPost(post){
                this.$parent.viewPost(post);
            },
            backToNormal(){
                this.$parent.backToNormal();
            },
            viewPostsFromCategory(data){
                this.$parent.viewPostsFromCategory(data);
            },
            viewPostsFromTag(data){
                this.$parent.viewPostsFromTag(data);
            }
        },
        components: {
            'blog-card': BlogCard
        },
    }
</script>
